import { client } from '../client';
import { ICase } from './types/ICase';

export type RescheduleCasePayload = {
  video_conference_date: string;
  clinician_id?: number;
  // Lets the backend pick the provider_id vs care_advisor_id column for
  // clinician_id — required for OHC cases, which have no provider.
  case_type?: string;
  // Only required when the backend reports the case still needs payment (a
  // linked multi-stage case being scheduled for the first time). Omit for a
  // genuine reschedule of an already-paid appointment.
  payment_profile_id?: number;
};

export const rescheduleCase = async (case_id: number, payload: RescheduleCasePayload): Promise<ICase> => {
  const { data } = await client.patch(`patients/reschedule_case/${case_id}`, payload);

  return data;
};

export const rescheduleCaseAsStaff = async (
  case_id: number,
  payload: RescheduleCasePayload,
  userRole?: string,
): Promise<ICase> => {
  const prefix = userRole === 'Collector' ? '/collector' : '/care_advisor';
  const { data } = await client.patch(`${prefix}/reschedule_case/${case_id}`, payload);

  return data;
};
